var _defs, _path, _path2, _path3, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorItsw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 268.23 70.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #211e1e;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.58,7.04c-15.64,0-28.32,12.63-28.32,28.21,0,6.73,2.37,12.91,6.32,17.76l-6.32,10.46,11.51-5.51c4.7,3.46,10.52,5.51,16.82,5.51,15.64,0,28.32-12.63,28.32-28.21s-12.68-28.21-28.32-28.21M233.39,44.2c-4.96,2.1-10.69-.21-12.79-5.15-2.11-4.94.21-10.64,5.17-12.74,4.96-2.1,10.69.21,12.79,5.15,2.1,4.94-.21,10.65-5.17,12.74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.12,29.31V7.13h4.74v22.19h-4.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.41,29.31V11.28h-6.51v-4.16h17.76v4.16h-6.48v18.03h-4.77Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.57,22.59c1.57,1.63,4.01,2.99,7.08,2.99,2.6,0,3.87-1.23,3.87-2.5,0-1.66-1.94-2.23-4.51-2.83-3.64-.83-8.31-1.83-8.31-6.79,0-3.69,3.21-6.69,8.45-6.69,3.54,0,6.48,1.06,8.68,3.09l-2.64,3.46c-1.8-1.66-4.21-2.43-6.38-2.43s-3.27.93-3.27,2.26c0,1.5,1.87,1.96,4.44,2.56,3.67.83,8.35,1.93,8.35,6.85,0,4.06-2.9,7.12-8.91,7.12-4.27,0-7.34-1.43-9.45-3.53l2.6-3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.54,29.31V7.13h15.76v4.06h-11.02v4.82h10.78v4.06h-10.78v5.16h11.02v4.09h-15.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.93,18.24c0-6.82,5.17-11.48,11.69-11.48,5.07,0,7.91,2.66,9.48,5.42l-4.07,2c-.93-1.8-2.94-3.23-5.41-3.23-3.87,0-6.81,3.09-6.81,7.29s2.94,7.29,6.81,7.29c2.47,0,4.47-1.4,5.41-3.23l4.07,1.96c-1.6,2.76-4.41,5.46-9.48,5.46-6.51,0-11.69-4.66-11.69-11.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.94,7.13h4.81v13.17c0,3.09,1.7,5.22,5.17,5.22s5.11-2.13,5.11-5.22V7.13h4.81v13.31c0,5.52-3.17,9.28-9.92,9.28s-9.98-3.79-9.98-9.25V7.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.84,29.31l-4.37-7.95h-3.47v7.95h-4.74V7.13h10.42c4.64,0,7.48,3.03,7.48,7.15s-2.47,6.02-4.87,6.59l5.01,8.45h-5.44ZM134.96,11.18h-4.97v6.12h4.97c1.9,0,3.34-1.2,3.34-3.06s-1.44-3.06-3.34-3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.72,29.31V7.13h4.74v22.19h-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.01,29.31V11.28h-6.51v-4.16h17.76v4.16h-6.48v18.03h-4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.51,29.31v-9.08l-8.58-13.11h5.41l5.54,8.92,5.48-8.92h5.41l-8.51,13.11v9.08h-4.74Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.34,63.37l-4.64-17.13-4.61,17.13h-3.57l-6.38-22.19h3.74l4.61,17.8,4.87-17.8h2.7l4.84,17.8,4.61-17.8h3.74l-6.34,22.19h-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.09,63.37v-22.19h3.34v22.19h-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.23,63.37l-5.31-8.55h-4.17v8.55h-3.34v-22.19h9.38c4.24,0,7.14,2.73,7.14,6.82s-2.7,6.12-5.54,6.49l5.71,8.88h-3.87ZM168.36,44.11h-5.61v7.78h5.61c2.4,0,4.14-1.56,4.14-3.89s-1.74-3.89-4.14-3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.04,63.37v-22.19h14.96v2.93h-11.62v6.49h11.38v2.93h-11.38v6.92h11.62v2.93h-14.96Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorItsw);
export default __webpack_public_path__ + "static/media/Color ITSW.999d4c3ab52dc31df76e1667c6f8bdf6.svg";
export { ForwardRef as ReactComponent };